<template>
  <!-- eslint-disable -->
  <v-snackbar vertical v-model="show" color="error" :timeout="timeout">
    <v-layout row xs12>
      {{message}}
    </v-layout>
    <v-btn dark text @click.native="show = false">Close</v-btn>
  </v-snackbar>
<!-- eslint-enable -->
</template>
<script>
import { EventBus } from "../../services/eventbus";
export default {
  data() {
    return {
      show: false,
      timeout: 90000,
      message: "",
      color: "error"
    };
  },
  mounted: /* istanbul ignore next */ function() {
    EventBus.$on("showglobaldialog", payload => {
      this.show = true;
      this.message = payload.title;
      this.color = payload.status;
    });
  }
};
</script>
